export default "__VITE_ASSET__BzX3HQgF__"